import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { handleGainAccessRedirect } from "app/common/utils/handleGainAccessRedirect";

const CompanyAutocompleteUpgradeBlock = ({ interval = "daily" }: { interval?: "daily" | "monthly" | "unlimited" }) => {
    const onClick = () => {
        handleGainAccessRedirect("Overviews hook", "click", "sales intelligence hooks", "Search box");
    };
    return (
        <Stack
            alignItems="flex-start"
            margin="8px"
            padding="10px 16px 16px"
            gap="4px"
            background={colorsPalettes.sky[100]}
        >
            <Text
                fontVariant="subtitle1"
                color={colorsPalettes.indigo["300"]}
            >
                {translate(`si.pages.home.search.autocomplete.quota.reached.title.${interval}`)}
            </Text>
            <Text
                fontVariant="body2"
                color={colorsPalettes.indigo["300"]}
                margin="0 0 8px 0"
            >
                {translate("si.pages.home.search.autocomplete.quota.reached.subtitle")}
            </Text>
            <IconButton
                type="trial"
                iconName="sparkles"
                onClick={onClick}
            >
                {translate("si.common.upgrade_now")}
            </IconButton>
        </Stack>
    );
};

export default CompanyAutocompleteUpgradeBlock;
